import React, {useMemo} from 'react';
import {PlayingStatus, SquadflixDevice, SquadflixTvHook} from "../../../hooks/useSquadflixTv";
import './styles.scss';
import {getDeviceIcon} from "../../../utils/devices-constants";
import {cn, getFlag} from "../../../utils/utils";
import {TitlePage} from "../../shared";
import {ScrollModal} from "../../shared/scroll-modal";
import {OptionButton} from "../../shared/option-button";
import {useSelector} from "react-redux";
import users from "../../users";

type Props = {
    squadflixTvHook?: SquadflixTvHook;
    isMobile?: boolean;
}

const SquadflixTvControls = ({squadflixTvHook}: Props) => {

    const [showDetails, setShowDetails] = React.useState(false);
    const [selectedMenu, setSelectedMenu] = React.useState<'videoType' | 'subtitles' | 'audioTrack' | null>(null);
    const scrollModalApi = React.useRef<any>();
    const darkMode = useSelector(users.selectors.isDarkMode)

    const device = useMemo((): SquadflixDevice | null => {
        return squadflixTvHook?.connectedReceptor || null;
    }, [squadflixTvHook?.connectedReceptor]);

    const mainItem = useMemo(() => {
        return squadflixTvHook?.video?.item?.serie || squadflixTvHook?.video?.item || null;
    }, [squadflixTvHook?.video]);

    const selectedAudio = useMemo(() => {
        if (squadflixTvHook?.playingStatus.selectedTrackIndex !== undefined && squadflixTvHook?.video?.audios.length > squadflixTvHook?.playingStatus.selectedTrackIndex) {
            return squadflixTvHook?.video?.audios[squadflixTvHook?.playingStatus.selectedTrackIndex];
        }
        return null;
    }, [squadflixTvHook?.playingStatus.selectedTrackIndex, squadflixTvHook?.video]);

    const selectedAudioDesc = useMemo(() => {
        if (selectedAudio) {
            return selectedAudio.language;
        }
        return 'Default';
    }, [selectedAudio]);

    const handleClickOption = (option: 'videoType' | 'subtitles' | 'audioTrack') => {
        if (scrollModalApi.current) {
            setSelectedMenu(option);
            scrollModalApi.current.open();
        }
    }

    const getTitleForOption = (option: 'videoType' | 'subtitles' | 'audioTrack') => {
        switch (option) {
            case 'videoType':
                return 'Modo de vídeo';
            case 'subtitles':
                return 'Subtítulos';
            case 'audioTrack':
                return 'Pista de audio';
            default:
                return '';
        }
    }

    const getIconForOption = (option: 'videoType' | 'subtitles' | 'audioTrack') => {
        switch (option) {
            case 'videoType':
                return 'fa-solid fa-video';
            case 'subtitles':
                return 'fa-solid fa-closed-captioning';
            case 'audioTrack':
                return 'fa-solid fa-headphones';
        }
    }

    const episodeTitle = useMemo(() => {
        if (squadflixTvHook?.video?.item?.serie) {
            return `S${squadflixTvHook?.video?.item?.season_number}E${squadflixTvHook?.video?.item?.episode_number} `;
        }

        return "";
    }, [squadflixTvHook?.video]);

    return <div className={cn("squadflix-tv-controls", {"squadflix-tv-controls-dark": darkMode})} style={{
        height: showDetails ? '170px' : '70px'
    }}>
        <div className="squadflix-tv-controls__upper">
            <div className="squadflix-tv-controls__col squadflix-tv-controls__info" onClick={() => {
                setShowDetails(!showDetails);
            }}>
                <div>
                    <i className={cn(getDeviceIcon(device.type), "pe-2")}/>{squadflixTvHook.connectedReceptor.name}
                </div>
                <div style={{
                    //max 1 line and ...
                    width: "100%",
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontWeight: 'bold'
                }}>
                    {episodeTitle}{mainItem?.name || mainItem?.title}
                </div>
            </div>
            {mainItem &&
                <div className="squadflix-tv-controls__col squadflix-tv-controls__buttons">
                    {squadflixTvHook.playingStatus.status === PlayingStatus.PLAYING &&
                        <button onClick={() => squadflixTvHook.controls.pause()}>
                            <i className="fa-solid fa-pause"></i>
                        </button>}
                    {squadflixTvHook.playingStatus.status !== PlayingStatus.PLAYING &&
                        <button onClick={() => squadflixTvHook.controls.resume()}>
                            <i className="fa-solid fa-play"></i>
                        </button>}
                </div>}
        </div>
        {
            squadflixTvHook.playingStatus.status === "idle" &&
            <div className="squadflix-tv-controls__lower text-center">
                <small>
                    Selecciona un contenido para reproducir en tu dispositivo
                </small>
            </div>
        }
        {
            mainItem &&
            <>
                <div className="squadflix-tv-controls__buttons">

                    <button onClick={() => squadflixTvHook.controls.forward(-30)}>
                        <i className="fa-solid fa-rotate-left"></i>
                        <span className="squadflix-tv-controls__control-button-tooltip" style={{
                            bottom: "48%",
                            left: "52%"
                        }}>
                            30
                        </span>
                    </button>
                    <button onClick={() => squadflixTvHook.controls.forward(-10)}>
                        <i className="fa-solid fa-rotate-left"></i>
                        <span className="squadflix-tv-controls__control-button-tooltip" style={{
                            bottom: "48%",
                            left: "52%"
                        }}>
                            10
                        </span>
                    </button>
                    <div style={{
                        width: 0,
                        height: 24,
                        border: '1px solid #D0CFCFDD',
                    }}>

                    </div>
                    <button onClick={() => squadflixTvHook.controls.forward(10)}>
                        <i className="fa-solid fa-rotate-right"></i>
                        <span className="squadflix-tv-controls__control-button-tooltip" style={{
                            bottom: "48%",
                            left: "48%"
                        }}>
                            10
                        </span>
                    </button>
                    <button onClick={() => squadflixTvHook.controls.forward(30)}>
                        <i className="fa-solid fa-rotate-right"></i>
                        <span className="squadflix-tv-controls__control-button-tooltip" style={{
                            bottom: "48%",
                            left: "48%"
                        }}>
                            30
                        </span>
                    </button>
                    {false &&
                        <button className="squadflix-tv-controls__stop-btn" onClick={squadflixTvHook.controls.stop}>
                            <i className="fa-solid fa-stop"></i>
                        </button>}
                </div>
                <div className="squadflix-tv-controls__details">
                    <div className="squadflix-tv-controls__details-col" onClick={() => handleClickOption('videoType')}>
                        <i className="fa-solid fa-video"></i>
                        {squadflixTvHook.playingStatus.videoType}
                    </div>
                    <div className="squadflix-tv-controls__details-col" onClick={() => handleClickOption('subtitles')}>
                        <i className="fa-solid fa-closed-captioning"></i>
                        {squadflixTvHook.playingStatus.currentSubtitle ? squadflixTvHook.playingStatus.currentSubtitle.lang : 'Off'}
                        &nbsp;<span className={getFlag(squadflixTvHook.playingStatus.currentSubtitle?.lang)}></span>
                    </div>
                    <div className="squadflix-tv-controls__details-col" onClick={() => handleClickOption('audioTrack')}>
                        <i className="fa-solid fa-headphones"></i>
                        {selectedAudioDesc}&nbsp;<span className={getFlag(selectedAudio?.language)}></span>
                    </div>
                </div>
            </>
        }
        {
            <div className="squadflix-tv-controls__progress">
                <div className="squadflix-tv-controls__progress-filled" style={{
                    width: (squadflixTvHook.playingStatus.currentTime / squadflixTvHook.playingStatus.videoDuration) * 100 + '%'
                }}>

                </div>
            </div>
        }
        {mainItem &&

            <ScrollModal header={
                <TitlePage style={{
                    height: "59px",
                }} icon={getIconForOption(selectedMenu) + " fa-lg"} hideSeparator
                           title={getTitleForOption(selectedMenu)} className="p-3 ps-1"
                           rightOptions={undefined}
                           titleClass={undefined} leftClass={"col-12"} rightClass={undefined}
                           disableScroll={undefined} fixedHeight={undefined}/>
            } ref={scrollModalApi}>
                {
                    selectedMenu === 'videoType' && <div>
                        <OptionButton
                            onClick={() => squadflixTvHook.controls.selectVideoType("streaming")}
                            text={
                                <div className="d-flex align-items-center">
                                    <span>Streaming</span>
                                    {squadflixTvHook.playingStatus.videoType === 'streaming' &&
                                        <i className="fa-solid fa-play ps-2"></i>}
                                </div>
                            }
                            icon={<i
                                className="fa-solid fa-tower-broadcast"></i>}
                            disabled={squadflixTvHook.playingStatus.videoType === 'streaming'}/>
                        <OptionButton
                            onClick={() => squadflixTvHook.controls.selectVideoType("original")}
                            text={
                                <div className="d-flex align-items-center">
                                    <span>Original</span>
                                    {squadflixTvHook.playingStatus.videoType === 'original' &&
                                        <i className="fa-solid fa-play ps-2"></i>}
                                </div>
                            }
                            icon={<i
                                className="fa-solid fa-file-video"></i>}
                            disabled={squadflixTvHook.playingStatus.videoType === 'original'}/>
                    </div>
                }
                {
                    selectedMenu === 'subtitles' && <>
                        {!squadflixTvHook?.video?.subtitles?.length &&
                            <div className="p-3">
                                <small>No hay subtítulos disponibles para este contenido.</small>
                            </div>
                        }
                        {!!squadflixTvHook?.video?.subtitles?.length &&
                            <>
                                <OptionButton
                                    onClick={() => squadflixTvHook.controls.selectSubtitle(null)}
                                    text={
                                        <div className="d-flex align-items-center">
                                            <span>Off</span>
                                            {!squadflixTvHook.playingStatus.currentSubtitle &&
                                                <i className="fa-solid fa-closed-captioning ps-2"></i>}
                                        </div>
                                    }
                                    icon={<i className="fa-solid fa-xmark"></i>}
                                    disabled={!squadflixTvHook.playingStatus.currentSubtitle}/>
                                {
                                    squadflixTvHook.video.subtitles.map((sub) => (
                                        <OptionButton
                                            key={sub.id}
                                            onClick={() => squadflixTvHook.controls.selectSubtitle(sub)}
                                            text={
                                                <div className="d-flex align-items-center">
                                                    <span>{sub.title ?? ""} {sub.lang}</span>
                                                    {squadflixTvHook.playingStatus.currentSubtitle?.id === sub.id &&
                                                        <i className="fa-regular fa-closed-captioning ps-2"></i>}
                                                </div>
                                            }
                                            icon={<span className={getFlag(sub.lang)}></span>}
                                            disabled={squadflixTvHook.playingStatus.currentSubtitle?.id === sub.id}/>
                                    ))
                                }
                            </>
                        }
                    </>
                }
                {
                    selectedMenu === 'audioTrack' && <div>
                        {!squadflixTvHook?.video?.audios?.length &&
                            <div className="p-3">
                                <small>No hay audios disponibles para este contenido.</small>
                            </div>
                        }
                        {!!squadflixTvHook?.video?.audios?.length &&
                            squadflixTvHook.video.audios.map((audio, i) => (
                                <OptionButton
                                    key={audio.id}
                                    onClick={() => squadflixTvHook.controls.changeTrack(i)}
                                    text={
                                        <div className="d-flex align-items-center">
                                            <span>{audio.label ?? ""} {audio.language}</span>
                                            {squadflixTvHook.playingStatus.selectedTrackIndex === i &&
                                                <i className="fa-solid fa-volume-high ps-2"></i>}
                                        </div>
                                    }
                                    icon={<span className={getFlag(audio.language)}></span>}
                                    disabled={squadflixTvHook.playingStatus.selectedTrackIndex === i}/>
                            ))
                        }
                    </div>
                }
            </ScrollModal>

        }
    </div>;
}

export default SquadflixTvControls;
